













import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import {
  UserNotificationUrlDto
} from '@eurogast/hub-client-typescript';

@Component({
  components: {NotificationUrlAttachment}
})
export default class NotificationUrlAttachment extends Vue {
  @Prop({required: false})
  public attachedUrl: UserNotificationUrlDto;
}
